module.exports = {
  upcoming: "upcoming",
  finished: "finished",
  waitingForApproval: "waitingForApproval",
  waitingForCheckout: "waitingForCheckout",
  history: "history",
  deprecated: "deprecated"
};
